import { rest } from 'msw';

import { baseUrl, soldProductsEndpoint, topSellingGarmentEndpoint } from '../../constants';

import { ProductDetails, SoldProductItem } from '../../hooks';
import { getGarments, mockProductIndex } from '../mocks';

export const getProducts = (count: number): SoldProductItem[] => {
  const garments: SoldProductItem[] = [];

  for (let i = 0; i < count; i++) {
    const garment: SoldProductItem = {
      productName: `Garment ${i + 1}`,
      productId: Math.floor(Math.random() * 10000000)
        .toString()
        .padStart(3, '0'),
      price:
        Math.random() < 0.5
          ? Number.parseFloat((Math.random() * 1000).toFixed(2))
          : Number.parseFloat((Math.random() * 12450).toFixed(2)),
      soldPieces: Math.floor(Math.random() * 10),
      departmentId: `${Math.floor(Math.random() * 1000000)}`,
      departmentNumber: `${Math.floor(Math.random() * (9999 - 1000 + 1)) + 1000}`,
      departmentName: Math.random() < 0.33 ? 'Dividend' : Math.random() < 0.66 ? 'H&M Kids' : 'H&M Menswear',
      season: Math.random() < 0.33 ? 'Summer' : 'Winter',
      salesNet: Math.floor(Math.random() * 1000),
      salesNetLastWeek: Math.floor(Math.random() * 1000),
      salesNetLastYear: Math.floor(Math.random() * 1000),
      mostSoldArticle: '001',
      index: Math.random() < 0.33 ? 'Dividend11' : Math.random() < 0.66 ? 'H&M Kids11' : 'H&M Menswear11',
      subIndex:
        Math.random() < 0.33
          ? 'Dividend Collection'
          : Math.random() < 0.66
          ? 'H&M Kids Collection'
          : 'H&M Menswear Collection',
    };

    garments.push(garment);
  }

  return garments;
};

const getProductDetails = (): ProductDetails => {
  const colors = ['Red', 'Blue', 'Green', 'Black', 'White', 'Yellow', 'Pink', 'Purple', 'Orange', 'Gray'];
  const sizes = ['XS', 'S', 'M', 'L', 'XL', 'XXL'];

  return {
    color: colors.sort(() => 0.5 - Math.random()).slice(0, Math.floor(Math.random() * colors.length) + 1),
    size: sizes.sort(() => 0.5 - Math.random()).slice(0, Math.floor(Math.random() * sizes.length) + 1),
  };
};

export const fetchSoldProductsPage = (addDelay = false) =>
  rest.get(`${baseUrl}${soldProductsEndpoint}/:storeId/soldProducts`, (_, res, ctx) => {
    const mockData = getProducts(324);

    return res(
      ctx.status(200),
      ctx.json(mockData),
      ctx.set('Content-Type', 'application/json'),
      ctx.delay(addDelay ? 500 : 0),
    );
  });

export const fetchSoldProductsDetails = (addDelay = false) =>
  rest.get(`${baseUrl}${soldProductsEndpoint}/:storeId/products/:productId/details`, (req, res, ctx) => {
    const mockData = getProductDetails();

    return res(
      ctx.status(200),
      ctx.json(mockData),
      ctx.set('Content-Type', 'application/json'),
      ctx.delay(addDelay ? 500 : 0),
    );
  });

export const fetchProductIndex = (addDelay = false) =>
  rest.get(`${baseUrl}${soldProductsEndpoint}/:storeId/productIndex`, (_, res, ctx) => {
    const mockData = mockProductIndex;

    return res(
      ctx.status(200),
      ctx.json(mockData),
      ctx.set('Content-Type', 'application/json'),
      ctx.delay(addDelay ? 500 : 0),
    );
  });

export const fetchTopSellingGarmentData = (addDelay = false) =>
  rest.get(`${baseUrl}${soldProductsEndpoint}/:storeId${topSellingGarmentEndpoint}`, (_, res, ctx) => {
    const mockData = getGarments();

    return res(
      ctx.status(200),
      ctx.json(mockData),
      ctx.set('Content-Type', 'application/json'),
      ctx.delay(addDelay ? 500 : 0),
    );
  });
